import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProfile } from '../../context/ProfileContext';
import './UserProfile.css';

function UserProfile() {
  const navigate = useNavigate();
  const { profile, logout } = useProfile();
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    dob: '',
    address: '',
    profilePic: null
  });

  useEffect(() => {
    // Simulating API call to fetch user data
    setLoading(true);

    // Mock user data
    const mockUserData = {
      name: 'John Doe',
      email: 'johndoe@example.com',
      phone: '+91 1234567890',
      dob: '1990-01-01',
      address: '123 Main Street, City, State, Country',
      profilePic: null
    };

    // Simulate API delay
    setTimeout(() => {
      setFormData(mockUserData);
      setLoading(false);
    }, 800);

  }, []);

  const handleBack = () => {
    navigate('/');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleProfilePicChange = (e) => {
    // Handle profile picture upload
    if (e.target.files && e.target.files[0]) {
      setFormData(prevData => ({
        ...prevData,
        profilePic: URL.createObjectURL(e.target.files[0])
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate API call to update profile
    setLoading(true);

    // Simulate API delay
    setTimeout(() => {
      setIsEditing(false);
      setLoading(false);
      // Show success message
      alert('Profile updated successfully!');
    }, 800);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="profile-container">
      <div className="profile-header">
        <button className="back-button" onClick={handleBack}>
          <span>←</span>
        </button>
        <h1>My Profile</h1>
      </div>

      {loading ? (
        <div className="loading">Loading profile data...</div>
      ) : (
        <>
          <div className="profile-card">
            <div className="profile-pic-container">
              {isEditing ? (
                <label className="profile-pic-upload">
                  <div className="profile-pic">
                    {formData.profilePic ? (
                      <img src={formData.profilePic} alt="Profile" />
                    ) : (
                      <span className="profile-initials">
                        {formData.name.charAt(0)}
                      </span>
                    )}
                    <div className="upload-overlay">
                      <span>Change</span>
                    </div>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleProfilePicChange}
                    style={{ display: 'none' }}
                  />
                </label>
              ) : (
                <div className="profile-pic">
                  {formData.profilePic ? (
                    <img src={formData.profilePic} alt="Profile" />
                  ) : (
                    <span className="profile-initials">
                      {profile.email.charAt(0)}
                    </span>
                  )}
                </div>
              )}
              <h2 className="profile-name">{profile.email}</h2>
              <p className="profile-email">{profile.email2 || "N/A"}</p>
            </div>

            {isEditing ? (
              <form className="profile-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>New Password</label>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                  />
                </div>


                <div className="form-actions">
                  <button
                    type="button"
                    className="cancel-button"
                    onClick={() => setIsEditing(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="save-button">
                    Save Changes
                  </button>
                </div>
              </form>
            ) : (
              <div className="profile-info">
                <div className="info-group">
                  <div className="info-label">Phone Number</div>
                  <div className="info-value">{'+91 ' + profile.username}</div>
                </div>

                <div className="info-group">
                  <div className="info-label">Date of Birth</div>
                  <div className="info-value">{profile.dob || "YEAR-DAY-MONTH"}</div>
                </div>

                <div className="info-group">
                  <div className="info-label">Address</div>
                  <div className="info-value">{profile.address || "N/A"}</div>
                </div>

                <button
                  className="edit-profile-button"
                  onClick={() => setIsEditing(true)}
                >
                  Edit Profile
                </button>
              </div>
            )}
          </div>

          <div className="profile-actions">
            <button className="action-button wallet" onClick={() => navigate('/wallet')}>
              <span className="action-icon">💰</span>
              My Wallet
            </button>

            <button className="action-button history" onClick={() => navigate('/history')}>
              <span className="action-icon">📜</span>
              History
            </button>

            <button className="action-button settings">
              <span className="action-icon">⚙️</span>
              Settings
            </button>

            <button className="action-button logout" onClick={handleLogout}>
              <span className="action-icon">🚪</span>
              Logout
            </button>
          </div>
        </>
      )}

      {/* Bottom Navigation */}
      <div className="bottom-nav">
        <a href="/" className="nav-item">
          <span className="nav-icon">🏠</span>
          Home
        </a>
        <a href="/wallet" className="nav-item">
          <span className="nav-icon">💰</span>
          Wallet
        </a>
        <a href="/history" className="nav-item">
          <span className="nav-icon">📜</span>
          History
        </a>
        <a href="/profile" className="nav-item active">
          <span className="nav-icon">👤</span>
          Profile
        </a>
      </div>
    </div>
  );
}

export default UserProfile; 